<script>
import CountInput from '@/components/common/CountInput.vue'
export default {
    components: {
        CountInput
    },
    props: {
        isNew: Boolean,
        price: {
            type: Number,
            default:900
        },
        patientId: String
    },
    data() {
        return {
            count: 1
        }
    },
    computed: {
        title() {
            if (this.isNew) {
                return '购买疗程'
            } else {
                return '疗程续费'
            }
        },
        total() {
            return (this.price * this.count)
        }
    },
    created() {
        console.log(this.patientId);
        
    },
    methods: {
        close() {
            this.$emit('close')
        },
        async confirm() {
            let result = await this.$http.pay({
                number: this.count,
                patientId: this.patientId,
                price: this.price
            })
            if (result) {
                this.$emit('payed')
            }
        }
    }
}
</script>

<template>
    <Dialog btn-text="提交" :title="title" @close="close" @confirm="confirm" >
        <div class="purchaseRow" >
            <p class="name" >疗程个数</p>
            <CountInput v-model="count" />
        </div>
        <div class="purchaseRow" >
            <p class="name" >支付金额</p>
            <p class="money" >￥{{total | toFixed}}</p>
        </div>
        <div class="tip" >
            <img src="@/assets/purchase_tip.svg" >
            <p>1个疗程60次训练，建议每天训练2次</p>

        </div>
    </Dialog>
</template>

<style lang="scss" scoped>
.purchaseRow {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    .name {
        padding-left: 21px;
        width: 99px;
        box-sizing: border-box;
        color:rgba(10,33,54,1);
    }
    .money {
        color:rgba(0,0,0,0.85);
        font-size: 20px;
    }
}
.tip {
    width:275px;
    height:32px;
    background:rgba(255,251,230,1);
    border-radius:4px;
    border:1px solid rgba(255,229,143,1);
    margin: 40px auto 19px;
    display: flex;
    align-items: center;
    color:rgba(0,0,0,0.65);
    >img {
        margin: 0 14px 0px 9px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/acount/PurchaseDialog.vue